import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const HolidayUserConfigDict = {
	enabled: {
		label: 'Feiertage',
		type: 'boolean',
		defaultValue: false as boolean,
		defaultOverrideSelector: selPropGen(PropID.feiertageDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.feiertageVis, propDefaultTrue),
	},
} as const
